// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ALLo8","addWidgetButton":"Header_addWidgetButton__KfndR","dashboardTabs":"Header_dashboardTabs__3LjTf","active":"Header_active__2C4Rb"};